const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "table.plan_approvals/SET_TABLE_PARAMS":
            return {
                ...state,
                ...action.params
            };
        case "table.plan_approvals/LIST_PLAN_APPROVALS_SUCCESS":
            return {
                ...state,
                data: action.response.data,
                filters: action.response.filters,
                ...action.response.pagination
            };
        default:
            return state;
    }
}
